import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import MogomaApp from '../src/mogoma/MogomaApp';

const PrivacyPolicy = lazy(() => import('../src/mogoma/PrivacyPolicy'));
const TermsOfService = lazy(() => import('../src/mogoma/TermsOfService'));
const DeleteAccountInstructions = lazy(() => import('../src/mogoma/AccountDeletion'));
const MDPProtectionTerms = lazy(() => import('../src/mogoma/MDPTerms'));

function MainRouter() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/mogoma" element={<MogomaApp />} />

          <Route path="/mogoma/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/mogoma/terms-of-service" element={<TermsOfService />} />
          <Route path="/mogoma/account-deletion" element={<DeleteAccountInstructions />} />
          <Route path="/mogoma/delivery-protection-terms" element={<MDPProtectionTerms />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default MainRouter;